/** @module csi/view/ToolbarInfo */
define([
	"dojo/_base/declare",
	"csi/view/ToolbarPlugin",
	"csi/widget/MaterialIconWithLabel"
], function(declare,ToolbarPlugin,MaterialIconWithLabel) {

	return declare([MaterialIconWithLabel, ToolbarPlugin], {
		"class": "csi-toolbar-info",
		inline: true,
		icon: "info",
		iconSize: 20,
		
		/**
		 * @override
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			this._mixinActionProperties();
			this.inherited(arguments);
		}
	});
});
